const cloneDate = (value) => {
  // Moment treats an omitted value as "now" but a null value as invalid.
  // Keep those edge cases for the callers that still accept optional dates.
  if (value === undefined) return new Date();
  if (value === null) return new Date(NaN);
  if (value instanceof Date) return new Date(value.getTime());
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(value);
};

export const isValidDate = (value) => !Number.isNaN(cloneDate(value).getTime());

export const startOfLocalDay = (value = new Date()) => {
  const date = cloneDate(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const endOfLocalDay = (value = new Date()) => {
  const date = cloneDate(value);
  date.setHours(23, 59, 59, 999);
  return date;
};

export const addMinutes = (value, minutes) => {
  const date = cloneDate(value);
  date.setMinutes(date.getMinutes() + minutes);
  return date;
};

export const isSameLocalDay = (first, second) => {
  const firstDate = cloneDate(first);
  const secondDate = cloneDate(second);
  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
};

export const subtractDays = (value, days) => {
  const date = cloneDate(value);
  date.setDate(date.getDate() - days);
  return date;
};

export const formatLocalDateTimeWithOffset = (value) => {
  const date = cloneDate(value);
  if (!isValidDate(date)) return 'Invalid date';

  const pad = (part) => String(part).padStart(2, '0');
  const offsetMinutes = -date.getTimezoneOffset();
  const offsetSign = offsetMinutes >= 0 ? '+' : '-';
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetRemainder = Math.abs(offsetMinutes) % 60;

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}${offsetSign}${pad(offsetHours)}:${pad(offsetRemainder)}`;
};

export const currentLocalTimestamp = () =>
  formatLocalDateTimeWithOffset(new Date());

export const formatNotificationDate = (value) => {
  const date = cloneDate(value);
  if (!isValidDate(date)) return 'Invalid date';
  const pad = (part) => String(part).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${String(
    date.getFullYear()
  ).slice(-2)}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const localDateAtCurrentTime = (dateString, now = new Date()) => {
  const [year, month, day] = String(dateString)
    .split('-')
    .map((part) => Number(part));
  return new Date(
    year,
    month - 1,
    day,
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    0
  );
};
